module.exports = {
  INIT: 'init',
  PENDED: 'pended',
  VERIFIED: 'verified',
  VALIDATED: 'validated',
  REFUSED: 'refused',
};
